/*
 * E-gift "myself vs friend" toggle (Gifting v2, plan G2.2a).
 *
 * Pure additive layer over Recharge's own gifting-widget app block (templates/product.egift_rc.json).
 * Never removes or renames any __rc_gift_* input; only shows/hides the widget's own recipient fieldset
 * and message field, and mirrors buyer-entered values into the widget's own (still-required) recipient
 * fields so its own validation and hidden-property mirroring keep working unchanged in "myself" mode.
 *
 * W4 (Sep 5 2026): required fields stay labeled. Inline errors on the exact
 * missing/invalid field (email). ATC enables when those existing required
 * fields are valid. Does not invent extra required fields.
 */
(function () {
  var HIDE_CLASS = 'egift-hidden-by-toggle';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function nativeSetValue(el, value) {
    if (!el) return;

    var proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(proto, 'value');

    if (descriptor && descriptor.set) {
      descriptor.set.call(el, value);
    } else {
      el.value = value;
    }

    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getWidgetRefs() {
    return {
      recipientBlock: document.querySelector('.rc_gifting_recipient_block'),
      recipientFirst: document.getElementById('rc_gift_recipient_first_name'),
      recipientLast: document.getElementById('rc_gift_recipient_last_name'),
      recipientEmail: document.getElementById('rc_gift_recipient_email'),
      senderName: document.getElementById('rc_gift_sender_name'),
      message: document.getElementById('rc_gift_message')
    };
  }

  function getMessageWrap(refs) {
    if (!refs.message) return null;
    var field = refs.message.closest('.field');
    return field ? field.parentElement : null;
  }

  function isValidEmail(value) {
    return EMAIL_RE.test((value || '').trim());
  }

  function ensureError(anchor, id) {
    var existing = document.getElementById(id);
    if (existing) return existing;
    if (!anchor) return null;
    var p = document.createElement('p');
    p.id = id;
    p.className = 'egift-field-error text-sm';
    p.setAttribute('role', 'alert');
    p.hidden = true;
    p.style.color = '#b42318';
    p.style.margin = '4px 0 0';
    var host = anchor.closest('.field') || anchor.closest('.form-control') || anchor.parentNode;
    if (host) host.appendChild(p);
    return p;
  }

  function setError(el, errorEl, message) {
    if (el) el.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (!errorEl) return;
    if (message) {
      errorEl.hidden = false;
      errorEl.textContent = message;
    } else {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function markRequiredLabel(input, text) {
    if (!input) return;
    input.setAttribute('aria-required', 'true');
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    if (!label) label = input.closest('.field') ? input.closest('.field').querySelector('label') : null;
    if (!label) return;
    if (label.getAttribute('data-egift-required-label') === '1') return;
    var base = (label.textContent || '').replace(/\s*\(required\)\s*$/i, '').trim();
    if (!base) base = text;
    label.textContent = base + ' (required)';
    label.setAttribute('data-egift-required-label', '1');
  }

  function findAddToCartButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('buy-buttons button[type="submit"], form[is="product-form"] button[type="submit"]'));
  }

  function setupToggle(toggleRoot) {
    var wrapper = toggleRoot.closest('.egift-mode-toggle');
    if (!wrapper) return;

    var radios = Array.prototype.slice.call(toggleRoot.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    var selfEmailWrap = wrapper.querySelector('[data-egift-self-email]');
    var selfEmailInput = selfEmailWrap ? selfEmailWrap.querySelector('input') : null;
    var selfEmailError = wrapper.querySelector('[data-egift-error="self-email"]');

    function currentMode() {
      var checked = radios.filter(function (radio) {
        return radio.checked;
      })[0];
      return checked ? checked.value : 'friend';
    }

    function mirrorSelfValues(refs) {
      var email = selfEmailInput ? selfEmailInput.value.trim() : '';
      var name = refs.senderName ? refs.senderName.value.trim() : '';

      nativeSetValue(refs.recipientEmail, email);
      nativeSetValue(refs.recipientFirst, name);
      nativeSetValue(refs.recipientLast, name);
    }

    function validate(showErrors) {
      var refs = getWidgetRefs();
      var mode = currentMode();
      var errors = [];

      if (mode === 'myself') {
        var selfVal = selfEmailInput ? selfEmailInput.value.trim() : '';
        var selfMsg = '';
        if (!selfVal) selfMsg = 'Enter your email.';
        else if (!isValidEmail(selfVal)) selfMsg = 'Enter a valid email.';
        if (showErrors || selfVal) setError(selfEmailInput, selfEmailError, showErrors ? selfMsg : (selfVal && selfMsg ? selfMsg : ''));
        else setError(selfEmailInput, selfEmailError, '');
        if (selfMsg) errors.push({ el: selfEmailInput, message: selfMsg });
      } else {
        setError(selfEmailInput, selfEmailError, '');
        var emailEl = refs.recipientEmail;
        var emailVal = emailEl ? emailEl.value.trim() : '';
        var emailErr = ensureError(emailEl, 'egift-error-recipient-email');
        var emailMsg = '';
        if (!emailVal) emailMsg = 'Enter the recipient email.';
        else if (!isValidEmail(emailVal)) emailMsg = 'Enter a valid email.';
        if (showErrors || emailVal) setError(emailEl, emailErr, showErrors ? emailMsg : (emailVal && emailMsg ? emailMsg : ''));
        else setError(emailEl, emailErr, '');
        if (emailMsg) errors.push({ el: emailEl, message: emailMsg });

        [refs.recipientFirst, refs.recipientLast].forEach(function (field) {
          if (!field || !field.required) return;
          var err = ensureError(field, 'egift-error-' + field.id);
          var val = (field.value || '').trim();
          var msg = !val ? 'Enter ' + ((field.getAttribute('placeholder') || field.id || 'this field').replace(/_/g, ' ')) + '.' : '';
          if (showErrors) setError(field, err, msg);
          else if (!val) setError(field, err, '');
          if (msg) errors.push({ el: field, message: msg });
        });
      }

      return errors;
    }

    function syncAtcState(showErrors) {
      var errors = validate(!!showErrors);
      var buttons = findAddToCartButtons();
      var valid = errors.length === 0;
      buttons.forEach(function (button) {
        if (button.hasAttribute('data-force-oos')) return;
        if (valid) {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        }
      });
      return valid;
    }

    function applyMode(mode) {
      var refs = getWidgetRefs();
      var messageWrap = getMessageWrap(refs);
      var isMyself = mode === 'myself';

      if (refs.recipientBlock) refs.recipientBlock.classList.toggle(HIDE_CLASS, isMyself);
      if (messageWrap) messageWrap.classList.toggle(HIDE_CLASS, isMyself);

      if (selfEmailWrap) selfEmailWrap.hidden = !isMyself;
      if (selfEmailInput) selfEmailInput.required = isMyself;

      markRequiredLabel(selfEmailInput, 'Your email');
      markRequiredLabel(refs.recipientEmail, 'Email');
      if (refs.recipientFirst && refs.recipientFirst.required) markRequiredLabel(refs.recipientFirst, 'First name');
      if (refs.recipientLast && refs.recipientLast.required) markRequiredLabel(refs.recipientLast, 'Last name');

      if (isMyself) {
        mirrorSelfValues(refs);
      } else {
        nativeSetValue(refs.recipientEmail, '');
        nativeSetValue(refs.recipientFirst, '');
        nativeSetValue(refs.recipientLast, '');
        nativeSetValue(refs.message, '');
      }
      syncAtcState(false);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applyMode(radio.value);
      });
    });

    if (selfEmailInput) {
      selfEmailInput.addEventListener('input', function () {
        if (currentMode() === 'myself') mirrorSelfValues(getWidgetRefs());
        syncAtcState(false);
      });
    }

    var initialRefs = getWidgetRefs();
    if (initialRefs.senderName) {
      initialRefs.senderName.addEventListener('input', function () {
        if (currentMode() === 'myself') mirrorSelfValues(getWidgetRefs());
        syncAtcState(false);
      });
    }
    if (initialRefs.recipientEmail) {
      initialRefs.recipientEmail.addEventListener('input', function () { syncAtcState(false); });
    }
    if (initialRefs.recipientFirst) {
      initialRefs.recipientFirst.addEventListener('input', function () { syncAtcState(false); });
    }
    if (initialRefs.recipientLast) {
      initialRefs.recipientLast.addEventListener('input', function () { syncAtcState(false); });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('button[type="submit"]');
      if (!button) return;
      var form = button.form || button.closest('form');
      if (!form || form.getAttribute('is') !== 'product-form') return;
      if (!form.querySelector('.recharge-gifting-widget, .rc_gifting_recipient_block, [data-egift-mode-toggle]')) return;
      if (!syncAtcState(true)) {
        event.preventDefault();
        event.stopPropagation();
        var first = validate(true)[0];
        if (first && first.el && typeof first.el.focus === 'function') first.el.focus();
      }
    }, true);

    if ('MutationObserver' in window) {
      var observeTarget = document.querySelector('.recharge-gifting-widget') || document.body;

      var observer = new MutationObserver(function () {
        var refs = getWidgetRefs();
        if (!refs.recipientBlock) return;

        var mode = currentMode();
        var isMyself = mode === 'myself';

        if (refs.recipientBlock.classList.contains(HIDE_CLASS) !== isMyself) {
          applyMode(mode);
        } else {
          syncAtcState(false);
        }
      });

      observer.observe(observeTarget, { childList: true, subtree: true });
    }

    applyMode(currentMode());
  }

  function init() {
    document.querySelectorAll('[data-egift-mode-toggle]').forEach(setupToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
